// utils/pkce.ts
export const generateRandomString = (length: number): string => {
  const charset =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
  let result = "";
  const array = new Uint8Array(length);
  crypto.getRandomValues(array);
  for (let i = 0; i < array.length; i++) {
    result += charset[array[i] % charset.length];
  }
  return result;
};

export const base64UrlEncode = (arrayBuffer: ArrayBuffer): string => {
  const bytes = new Uint8Array(arrayBuffer);
  let binary = "";
  for (let i = 0; i < bytes.length; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary)
    .replace(/\+/g, "-")
    .replace(/\//g, "_")
    .replace(/=+$/, "");
};

export const generatePKCE = async (): Promise<{
  codeVerifier: string
  codeChallenge: string
}> => {
  const codeVerifier = generateRandomString(64);
  const digest = await crypto.subtle.digest(
    "SHA-256",
    new TextEncoder().encode(codeVerifier),
  );
  const codeChallenge = base64UrlEncode(digest);
  localStorage.setItem("pkce_verifier", codeVerifier);
  return { codeVerifier, codeChallenge };
};

export const buildB2CLoginUrl = async (
  policy: "B2C_1_Earfit_Dev" | "B2C_1_Earfit_PWD_RESET_Dev" = "B2C_1_Earfit_Dev"
): Promise<string> => {
  const { codeChallenge } = await generatePKCE();
  const state = generateRandomString(8);
  const nonce = generateRandomString(8);

  const TENANT = "salemappb2c";
  const CLIENT_ID = process.env.REACT_APP_B2C_CLIENT_ID ?? "";
  const REDIRECT_URI = process.env.REACT_APP_B2C_REDIRECT_URI ?? "";
  const SCOPE = process.env.REACT_APP_B2C_SCOPE ?? "https://salemappb2c.onmicrosoft.com/api/demo.read";
  const RESPONSE_MODE = "query";
  const RESPONSE_TYPE = "code";

  const url =
    `https://${TENANT}.b2clogin.com/${TENANT}.onmicrosoft.com/oauth2/v2.0/authorize` +
    `?p=${policy}` +
    `&client_id=${encodeURIComponent(CLIENT_ID)}` +
    `&redirect_uri=${encodeURIComponent(REDIRECT_URI)}` +
    `&response_type=${encodeURIComponent(RESPONSE_TYPE)}` +
    `&response_mode=${encodeURIComponent(RESPONSE_MODE)}` +
    `&scope=${encodeURIComponent(`openid offline_access ${SCOPE}`)}` +
    `&state=${encodeURIComponent(state)}` +
    `&nonce=${encodeURIComponent(nonce)}` +
    `&code_challenge=${encodeURIComponent(codeChallenge)}` +
    `&code_challenge_method=S256`;

  return url;
};
